module.exports = __webpack_public_path__ + "img/qygl.1d25357a.svg";